import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStoreDetails } from '../../services/api';

export const loadStoreDetail = createAsyncThunk(
    'storeDetail/load',
    async ({ storeId }, { rejectWithValue }) => {
        try {
            const response = await getStoreDetails(storeId);
            return response.data; // { store, rewards, vouchers }
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to load store details');
        }
    }
);

const initialState = {
    open: false,
    storeId: null,
    store: null,
    rewards: [],
    vouchers: [],
    loading: false,
    error: null,
};

const storeDetailSlice = createSlice({
    name: 'storeDetail',
    initialState,
    reducers: {
        openStoreDetail(state, action) {
            state.open = true;
            state.storeId = action.payload;
            state.store = null;
            state.rewards = [];
            state.vouchers = [];
            state.error = null;
        },
        closeStoreDetail(state) {
            state.open = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadStoreDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadStoreDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.store = action.payload?.store || null;
                state.rewards = action.payload?.rewards?.data || [];
                state.vouchers = action.payload?.vouchers?.data || [];
            })
            .addCase(loadStoreDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load store details';
            });
    },
});

export const { openStoreDetail, closeStoreDetail } = storeDetailSlice.actions;
export default storeDetailSlice.reducer;